module.exports = __webpack_public_path__ + "804af1db251fa505ec35e5094c8ceb35.png";